import { useJsApiLoader } from '@react-google-maps/api';
import { createContext, ReactNode } from 'react';

interface GoogleMapsProviderProps {
	apiKey: string;
	children: ReactNode;
}

interface GoogleMapsConsumerProps {
	isLoaded?: boolean;
	loadError?: Error;
}

const GoogleMapsContext = createContext<GoogleMapsConsumerProps>({});

const { Consumer: GoogleMapsConsumer } = GoogleMapsContext;

let place = 'places' as const;
const libraries = [place];

export function GoogleMapProvider({ apiKey, children }: GoogleMapsProviderProps) {
	const { isLoaded, loadError } = useJsApiLoader({
		googleMapsApiKey: apiKey,
		libraries,
		version: 'beta',
	});

	return <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>{children}</GoogleMapsContext.Provider>;
}

export { GoogleMapsConsumer, GoogleMapsContext };
